import { View, Text as PDFText } from '@react-pdf/renderer'

import { Policies } from '../../../../../types/bookingDetails'
import styles from './styles/index.styles'

interface ModifyTermsAndConditionsProps {
  modifyPolicies: Policies[]
  modifyPolicyDescription: string[]
  splitTextByWords(inputString: string, maxLength: number): string[]
}
export const ModifyTermsAndConditions = ({
  modifyPolicies,
  modifyPolicyDescription,
  splitTextByWords
}: ModifyTermsAndConditionsProps) => {
  const hasShortPolicy = modifyPolicies.some((ele) => ele.deadline <= 4320)

  const hasValidDescription =
    modifyPolicyDescription.length > 0 &&
    modifyPolicyDescription.some(
      (d) => d.trim().length > 3 && !d.includes('\n')
    )

  if (!hasValidDescription && !hasShortPolicy) return <View />

  return (
    <View style={styles.mainDiv} wrap>
      <View style={styles.titleContainer}>
        <PDFText style={styles.mainTitle}>شرایط و مقررات تغییر</PDFText>
      </View>
      <View style={styles.content}>
        {hasValidDescription
          ? modifyPolicyDescription.map((item, index) => {
              // if it contains \n, keep as single segment
              const segments =
                item.includes('\n') || true
                  ? [item]
                  : splitTextByWords(item, 130)

              return segments.map((segment, segIndex) => (
                <View
                  key={`${index}-${segIndex}`}
                  style={
                    segIndex === 0
                      ? styles.singleParagraph
                      : styles.singleParagraphShort
                  }>
                  <View style={styles.title}>
                    <PDFText>
                      {/* {segment.replace(/\(|\)/g, ($1) =>
                        $1 === ')' ? '(' : ')'
                      )} */}
                      {segment}
                    </PDFText>
                  </View>
                </View>
              ))
            })
          : modifyPolicies.map((item, index) => {
              // your existing switch logic for policy types
              switch (item.policyType) {
                case 'ReservationTime':
                case 'CheckInTime':
                case 'AfterCheckInTime':
                case 'BeforeCheckOutTime':
                  if (item.deadline > 4320) return <View key={index} />
                  return (
                    <View key={index} style={styles.singleParagraph}>
                      <View style={styles.title}>
                        <PDFText>
                          {item.deadline % 24 === 0
                            ? Math.floor(item.deadline / 24)
                            : item.deadline}{' '}
                        </PDFText>
                        <PDFText>
                          {item.deadline % 24 === 0 ? 'روز' : 'ساعت'}{' '}
                        </PDFText>
                        <PDFText>
                          {item.policyType === 'AfterCheckInTime' ||
                          item.policyType === 'ReservationTime'
                            ? ' :بعد از زمان رزرو '
                            : item.policyType === 'CheckInTime'
                            ? ' :قبل از زمان ورود '
                            : ' :قبل از زمان خروج '}
                        </PDFText>
                      </View>
                      <View style={styles.description}>
                        <PDFText>{item.penaltyAmount}% </PDFText>
                        <PDFText> از</PDFText>
                        <PDFText>
                          {item.penaltyType === 'FirstNight'
                            ? ' هزینه شب اول'
                            : ' قیمت کل '}
                        </PDFText>
                        <PDFText>به عنوان جریمه کسر خواهد شد.</PDFText>
                      </View>
                    </View>
                  )
                default:
                  return <View key={index} />
              }
            })}
      </View>
    </View>
  )
}
